import { render, staticRenderFns } from "./MergeTagSidebar.vue?vue&type=template&id=84a2a296&"
import script from "./MergeTagSidebar.vue?vue&type=script&lang=js&"
export * from "./MergeTagSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports